import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { Router } from "@angular/router";

@Component({
  selector: 'app-plan-type-options',
  standalone: false,
  templateUrl: './plan-type-options.component.html',
  styleUrl: './plan-type-options.component.scss'
})
export class PlanTypeOptionsComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  data: any;
  createNewUrl: any;
  createNewUrlMeter: any;
  pageTitle: any;

  constructor(
    private router: Router,
    public modalRef : BsModalRef,
    private languageTranslateService: LanguageTranslateService,
  ){
    super();
  }

  ngOnInit(): void {
    console.log("data",this.data)
    this.getLanguageData();

  }
  //Language
  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => { 
      if(Object.keys(data).length != 0){
        this.translate = data
        this.getPageTitleAndUrl()
      }
    }))
    console.log("translate",this.translate)
  }

  push(obs:any) {
    super.push(obs);
  }

  openPlanBased( planType: string) {
    if (planType === 'Time-based') {
      this.router.navigate([this.createNewUrl]);
    } else if (planType === 'Time Meter based') {
      this.router.navigate([this.createNewUrlMeter]);
    }
    this.modalRef.hide();
  }

  getPageTitleAndUrl() {

   if(this.data.maintenanceType == 'ASSET'){
    this.createNewUrl='dashboard/preventative-maintenance-standalone/assetsList/createByAssetTimeBased'
    this.createNewUrlMeter='dashboard/preventative-maintenance-standalone/assetsList/createByAssetTimeBasedMeterBased'
    this.pageTitle = 'Asset Maintenance Plans'
  } else if(this.data.maintenanceType == 'SITE'){
    this.createNewUrl='dashboard/preventative-maintenance-standalone/sitesList/createBySiteTimeBased'
    this.createNewUrlMeter='dashboard/preventative-maintenance-standalone/sitesList/createBySiteTimeBasedMeterBased'
    this.pageTitle = 'Site Maintenance Plans'
  }else{
    this.createNewUrl='dashboard/preventative-maintenance-standalone/recurringList/createByGenericTimeBased'
    this.createNewUrlMeter='dashboard/preventative-maintenance-standalone/recurringList/createByGenericTimeBasedMeterBased'
    this.pageTitle = 'Recurring Maintenance Plans'
  }
}
}
